import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/src/modules/HomePage/ListBot.tsx");
